import React from 'react';

// TODO [cards] What does this component look like?
const CardElementNoPrint = () => {
  return <div className="card-element-noprint" />;
};

export default CardElementNoPrint;
